import { getSessionDerivedTable, type StoredDerivedTableResult } from "@/app/providers/services";
import { useQuery, type UseQueryResult } from "react-query";

/**
 * Fetch the derived table rows persisted for a session version - computed once at solve time (not
 * recomputed here), grouped by entity instance. Toolbar and grid both call this with the same
 * (requestId, derivedTableId) pair so react-query's cache shares one fetch between them without
 * either needing to hold or pass down the result itself.
 */
export const useStoredDerivedTable = (
  requestId: string | undefined,
  derivedTableId: string | undefined | null,
): UseQueryResult<StoredDerivedTableResult> =>
  useQuery(
    ["sessionDerivedTable", requestId, derivedTableId],
    () => getSessionDerivedTable(requestId as string, derivedTableId as string),
    { enabled: !!requestId && !!derivedTableId },
  );
